export const vk = {
  vk: {
    shape:
      '<path stroke="#050505" stroke-linecap="round" stroke-linejoin="round" d="M10.485 7H12.624V17.693H12.621C10.419 17.693 8.00001 16.356 6.28301 13.891C3.70701 10.28 3.00301 7.55 3.00301 7 M21 17.693C21 17.693 20.222 16.053 18.644 14.248C17.592 13.015 16.11 12.347 14.762 12.347C16.11 12.347 17.592 11.679 18.644 10.446C20.222 8.64 21 7 21 7 M14.76 12.35H12.62"/>',
    viewBox: [0, 0, 24, 24],
  },
};
